import React from "react";
import { Container } from "./styles";
import Board from "./Board";

const Reports: React.FC = () => {
  return (
    <Container>
      <Board />
    </Container>
  );
};

export default Reports;
